import React, {useState} from 'react';
import {useDispatch} from 'react-redux';

import {connectNewDB, connectNewSQLite} from '../../../../modules/admin/database';
import getDBTypeIcon from '../../../../utils/getDBTypeIcon';
import getDisplayDBType from '../../../../utils/getDisplayDBType';
import INPUT_PATTERNS from '../../../../utils/inputPatterns';
import validateText from '../../../../utils/validateText';
import styles from './styles/database-info.module.css';

import UploadButton from './UploadButton';
import ButtonText from '../../../design-system/button/ButtonText';
import ButtonRadius50 from '../../../design-system/button/ButtonRadius50';
import TextField from '../../../design-system/text-field/TextField';
import {ReactComponent as SelectButton} from '../../../../assets/design-system/button/select.svg';

export default function DatabaseInfo({ connectionInfo, aliasNameList, setCurrentStepName, changeConnectionInfo, initializeConnectionInfo, toggleAddModal }) {
    const dispatch = useDispatch();
    
    const [error, setError] = useState({
        aliasNameError: null // null, valid, invalid (검증 전 / 검증 성공 / 검증 실패)
    });

    const { dbType, dbName, hostName, portNumber, accessId, dbPassword, dbFile, dbFileName, aliasName } = connectionInfo;

    const aliasInfoArray = [
        '글자 수 : 2자 이상, 20자 이하 [공백 불가]',
        '특수문자 제한 : \\ / : * ? " ` < > | # % & { } ^ ~',
        '연속된 특수문자 제한 : 연속된 하이픈(-)이나 언더바(_)'
    ];

    const handleChange = (e) => {
        const { name, value } = e.target;

        if (name === 'aliasName') {
            const validationOptions = {
                aliasName: {
                    minLength: 2,
                    maxLength: 20,
                    specialCharList: /[\\/:*?"`<>|#%&{}^~]/,
                    includeEmptyText: true
                }
            };

            const validation = validateText(value, validationOptions[name]);
            const isDuplicated = aliasNameList.includes(value);

            setError({
                ...error,
                [`${name}Error`]: (!validation.isValid || isDuplicated) ? 'invalid' : 'valid'
            });
        }

        changeConnectionInfo(name, value);
    };

    const movePreStep = () => {
        initializeConnectionInfo();
        setCurrentStepName('type');
    };

    const moveNextStep = () => {
        setCurrentStepName('test');

        if (dbType === 'SQLITE') {
            const formData = new FormData();
        
            // 필요한 데이터 추가
            formData.append('dbType', dbType);
            formData.append('dbName', dbName);
            formData.append('aliasName', aliasName);
            formData.append('dbFile', dbFile);
        
            dispatch(connectNewSQLite(formData));
        } else {
            dispatch(connectNewDB({
                ...connectionInfo,
                password: dbPassword
            }));
        }

    };

    const getBtnStatus = () => {
        if (error.aliasNameError === 'invalid') return 'inactive';
    
        if (dbType === 'SQLITE') {
            return (dbName.trim() && dbFile && aliasName.trim()) ? 'active' : 'inactive';
        }

        return (
            dbName.trim() &&
            hostName.trim() &&
            portNumber.trim() &&
            accessId.trim() &&
            dbPassword.trim() &&
            aliasName.trim()
        ) ? 'active' : 'inactive';
    };   

    return (
        <div className={styles.wrapper}>
            <TextField
                width='430px'
                label='DB 타입'
                placeholder='DB 타입'
                name='dbType'
                value={getDisplayDBType(dbType)}
                leadingIcon={getDBTypeIcon(dbType, { width: '30px', height: '30px' })}
                trailingIcon={connectionInfo.id ? null : <SelectButton />}
                handleChange={null}
                handleClickTrailingIcon={movePreStep}
            />
            <TextField
                width='430px'
                label='DB명'
                placeholder='DB명을 입력해 주세요'
                name='dbName'
                value={dbName}
                handleChange={handleChange}
            />
            {dbType === 'SQLITE'
                ? <div className={styles.boxSqlite}>
                    <TextField
                        width='778px'
                        label='DB 파일'
                        placeholder='DB 파일을 선택해 주세요'
                        name='dbFileName'
                        value={dbFileName}
                        handleChange={null}
                    />
                    <UploadButton changeConnectionInfo={changeConnectionInfo} />  
                </div>
                : <>
                    <TextField
                        width='660px'
                        label='호스트'
                        placeholder='호스트 주소를 입력해 주세요'
                        name='hostName'
                        value={hostName}
                        handleChange={handleChange}
                    />
                    <TextField
                        width='200px'
                        label='포트'
                        placeholder='포트 번호를 입력해 주세요'
                        name='portNumber'
                        value={portNumber}
                        pattern={INPUT_PATTERNS.ONLY_NUMBERS}
                        handleChange={handleChange}
                    />
                    <TextField
                        width='430px'
                        label='사용자명'
                        placeholder='사용자명을 입력해 주세요'
                        name='accessId'
                        value={accessId}
                        pattern={INPUT_PATTERNS.NO_KOREAN}
                        handleChange={handleChange}
                    />
                    <TextField
                        width='430px'
                        label='비밀번호'
                        placeholder='비밀번호를 입력해 주세요'
                        name='dbPassword'
                        value={dbPassword}
                        isPassword
                        pattern={INPUT_PATTERNS.NO_KOREAN}
                        handleChange={handleChange}
                    />
                </>

            }
            <TextField
                width='100%'
                label='별칭'
                maxCount='20'
                placeholder='별칭을 입력해 주세요'
                name='aliasName'
                value={aliasName}
                validationStatus={error.aliasNameError}
                guideMap={aliasInfoArray}
                handleChange={handleChange}
            />
            <div className={styles.boxButton}>
                <ButtonText
                    height='H18'
                    text='취소'
                    handleClick={connectionInfo.id ? toggleAddModal : movePreStep}
                />
                <ButtonRadius50
                    width='100px'
                    height='H40'
                    status={getBtnStatus()}
                    text='테스트'
                    handleClick={moveNextStep}
                />
            </div>
        </div>
    );
}
